export class AppGroupSharing {
    
    constructor(gudhub, req) {
      this.req = req;
      this.gudhub = gudhub;
      
    }

    //********************* ADD APP TO GROUP *********************//

    async addAppToGroupApi(appId, groupId, permission) {
      try {
          const form = {
              token: await this.gudhub.auth.getToken(),
              app_id: appId,
              group_id: groupId,
              app_permission: permission
          };
          const group = await this.req.post({
              url: "/api/sharing-group/add-app-to-group",
              form,
          });
          return group;
      } catch (err) {
          console.log(err);
          return null;
      }
    }

    //********************* GET APPS BY GROUP *********************//

    async getAppsByGroupApi(groupId) {
      try {
          const form = {
              token: await this.gudhub.auth.getToken(),
              group_id: groupId
          };
          const group = await this.req.post({
              url: "/api/sharing-group/get-apps-by-group",
              form,
          });
          return group;
      } catch (err) {
          console.log(err);
          return null;
      }
    }

    //********************* UPDATE APP IN GROUP *********************//

    async updateAppInGroupApi(appId, groupId, permission) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                group_id: groupId,
                app_id: appId,
                app_permission: permission
            };
            const group = await this.req.post({
                url: "/api/sharing-group/update-app-in-group",
                form,
            });
            return group;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    //********************* DELETE APP FROM GROUP *********************//

    async deleteAppFromGroupApi(appId, groupId, permission) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                group_id: groupId,
                app_id: appId,
                app_permission: permission
            };
            const group = await this.req.post({
                url: "/api/sharing-group/delete-app-from-group",
                form,
            });
            return group;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    //********************* GET GROUPS BY APP *********************//

    async getGroupsByAppApi(appId) {
        try {
            const form = {
                token: await this.gudhub.auth.getToken(),
                app_id: appId
            };
            const group = await this.req.post({
                url: "/api/sharing-group/get-groups-by-app",
                form,
            });
            return group;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

}
  